import "./NotificationHeader.css";
// import { FaBell } from "react-icons/fa6";
import React from "react";

const NotificationHeader = ({ name }) => {
  return (
    <>
      <div className="notificationHeader">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 col-9">
              <h2 className="PageTitle">{name}</h2>
            </div>
            <div className="col-lg-6 col-md-6 col-3">
              <div className="text-end">
                {/* <button className="noficationBtn" type="button">
                  <FaBell />
                  <span className="dot"></span>
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotificationHeader;
